// extracted by mini-css-extract-plugin
export default {"window":"TextMask-module--window--9b650","word":"TextMask-module--word--16dfe"};